<template>
	<div style="height: calc(100vh - 135px);overflow: auto;padding-right:3px">
		<div>
			<div class="page_header" style="margin-bottom:10px">
				<span class="page_title"
					style="flex: 1;float:left">{{$t("maintenancemanagement.accidentmanage")}}</span>
				<el-form :inline="true" :model="vehicleselect" class="demo-form-inline" size="mini">
					<el-form-item  :label="$t('maintenancemanagement.carNo')" >
						<el-input v-model="vehicleselect.carno" :placeholder="$t('maintenancemanagement.inputcarNo')" clearable></el-input>
					</el-form-item>
				</el-form>

			</div>
			<generalOrQuickQuery :speedShow="false" :addstate="true" @handleQuery="handleQuery" @quickQuery="quickQuery" :newsearchType="newsearchType"
				@newadd="newaccident" style="text-align: right" @download="download" />
			<div style="background: #C5D0E2;height: 1px;margin:20px  0px"></div>
			<div style="display: flex;flex-direction: row;height: 100%;margin:20px 0px 20px 0px">
				<!-- <div style="display: flex;flex-direction: row;margin-left: 40px;margin-right: 30px;position: relative;">
					<i style="vertical-align: -9%;margin-right: 10px;" class="iconfont icon-icon_tab_list"></i>
					<span style="font-size: 12px;font-weight: bold;display: contents;">事故统计列表</span>

				</div> -->
				<!-- 
				<div class="addbutton" @click="newaccident">
					<el-link :underline="false" style="margin-right:20px"><i class="el-icon-plus"
							style="height: 16px;width:16px;font-weight:bold;"></i>
						{{$t("public.newbuilt")}}</el-link>
				</div> -->
			</div>
			<div style="margin: 20px 0px 0px;">
				<el-table :data="tableData" border style="width:100%" :size="size" max-height="386">
					<el-table-column type="index"  align="center" :label="$t('public.index')">
					</el-table-column>
					<el-table-column prop="CarNo" :label="$t('runState.carNo')" align="center" width="100" >
					</el-table-column>
					<el-table-column prop="Driver" :label="$t('drivermanagement.driver')"align="center" >
					</el-table-column>

					<el-table-column prop="AccidentTime" :label="$t('accidentManagement.accidentTime')" align="center" width="100">
					</el-table-column>
					<el-table-column prop="OurresponsibleWeight" :label="$t('accidentManagement.ourresponsible')" align="center" >
					</el-table-column>
					<el-table-column prop="TotalCompensation" :label="$t('accidentManagement.totalAmount')+$t('public.unit')"  align="center"  show-overflow-tooltip>
					</el-table-column>
					<el-table-column prop="InsuranceUnderwrite" :label="$t('accidentManagement.assurancecompany')+$t('public.unit')" align="center"   show-overflow-tooltip>
					</el-table-column>
					<el-table-column prop="OurcompanyBear" :label="$t('accidentManagement.assumedbycompany')+$t('public.unit')" align="center"  show-overflow-tooltip>
					</el-table-column>
					<el-table-column prop="TheotherSideBear" :label="$t('accidentManagement.otherparty')+$t('public.unit')" align="center" show-overflow-tooltip>
					</el-table-column>
					<el-table-column prop="PersonResponseBear" :label="$t('accidentManagement.responsibleperson')+$t('public.unit')"  align="center"  show-overflow-tooltip>
					</el-table-column>
					<el-table-column prop="AccidentSpot" :label="$t('accidentManagement.accidentlocation')" align="center" show-overflow-tooltip>
					</el-table-column>
					<el-table-column prop="AccidentDescription" :label="$t('accidentManagement.accidentDescription')" align="center"  show-overflow-tooltip>
					</el-table-column>
					<el-table-column :label="$t('public.Operation')" align="center" width="150" fixed="right">
						<template slot-scope="scope">
							<el-button size="mini" type='success' @click="modify(scope.$index, scope.row)">{{ $t("public.edit")
				    }}</el-button>
							<el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">{{ $t("public.del")
				    }}</el-button>
						</template>
					</el-table-column>
				</el-table>
				<!-- 	<div style="text-align: right;margin-top:8px;margin-right: 40px" class="pagination" v-show="total>0">
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize"
						layout="total, sizes, prev, pager, next, jumper" :total="total">
					</el-pagination>
				</div> -->
				<el-dialog class="addrepairlist" :title="accidenttitle" :visible.sync="dialogFormVisible"
				:width="LanguageId  == 1 ? '600px' : '830px'" :close-on-click-modal="false">
					<div style="background:#E8F0FF;height: 1px;"></div>
					<div class="registrationInfo">
						{{$t('maintenance.basicInfo')}}
					</div>
					<el-row>
						<el-col :span="12">
							<div class="grid-content bg-purple">
								<el-form label-position="right" :label-width="(LanguageId  == 1 ||LanguageId  == 2) ? '100px' : '230px'"  :model="accidentRegistration"
									:rules="rules" ref="accidentRegistration" size="mini">
									<el-form-item :label="$t('maintenance.OPTName')+'：'" style="margin-top: 15px;">
										<el-input v-model="accidentRegistration.DataEntryClerk"
											:placeholder="$t('maintenancemanagement.inputperson')"></el-input>
									</el-form-item>
									<el-form-item class="carno" :label="$t('maintenancemanagement.carNo')" prop="VID"
										style="margin-top: 15px;">
										<el-select size="mini" filterable v-model="accidentRegistration.VID" 
											:placeholder="$t('public.select')">
											<el-option v-for="item in vehicles.data" v-if="item.treeLevel == 5"
												:key="item.nodeValue" :label="item.vehicleName" :value="item.nodeValue">
											</el-option>
										</el-select>
									</el-form-item>
									<el-form-item :label="$t('drivermanagement.driver')+'：'" style="margin-top: 15px;" prop="Driver">
										<el-input v-model="accidentRegistration.Driver" :placeholder="$t('drivermanagement.inputdriver')"></el-input>
									</el-form-item>

								</el-form>

							</div>
						</el-col>
						<el-col :span="12">
							<div class="grid-content bg-purple-light">
								<el-form label-position="right"  :model="accidentRegistration" :label-width="(LanguageId  == 1 ||LanguageId  == 2) ? '100px' : '230px'"
									size="mini">
									<el-form-item :label="$t('maintenance.entryTime')+'：'" style="margin-top: 15px;">
										<el-date-picker type="date" :placeholder="$t('accidentManagement.inputtime')"
											v-model="accidentRegistration.InputTime" style="width: 100%;"
											value-format="yyyy-MM-dd" :picker-options="pickerOptions"></el-date-picker>
									</el-form-item>

									<el-form-item :label="$t('accidentManagement.accidentTime')+'：'" style="margin-top: 15px;">
										<el-date-picker type="date" :placeholder="$t('accidentManagement.inputaccidentTime')"
											v-model="accidentRegistration.AccidentTime" style="width: 100%;"
											value-format="yyyy-MM-dd" :picker-options="pickerOptions"></el-date-picker>

									</el-form-item>
								</el-form>
							</div>
						</el-col>
					</el-row>
					<div class="registrationInfo">
						{{$t('accidentManagement.compensationInfo')}}
					</div>
					<el-row>
						<el-col :span="12">
							<div class="grid-content bg-purple">
								<el-form :model="accidentRegistration" class="demo-form-inline" label-position="right"
									size="mini" :label-width="(LanguageId  == 1 ||LanguageId  == 2) ? '100px' : '230px'" style="margin-top: 15px;">
									<el-form-item :label="$t('accidentManagement.totalAmount')+'：'" style="margin-top: 15px;" prop="TotalCompensation">
										<el-input v-model="accidentRegistration.TotalCompensation"  maxlength="7"
											onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
											:placeholder="$t('accidentManagement.inputtotalAmount')"></el-input>
									</el-form-item>
									<el-form-item :label="$t('accidentManagement.assurancecompany')+'：'" style="margin-top: 15px;" prop="InsuranceUnderwrite">
										<el-input v-model="accidentRegistration.InsuranceUnderwrite" 
											onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"  maxlength="7"
									:placeholder="$t('accidentManagement.inputassurancecompany')"></el-input>
									</el-form-item>
									<el-form-item :label="$t('accidentManagement.otherparty')+'：'" style="margin-top: 15px;" prop="TheotherSideBear">
										<el-input v-model="accidentRegistration.TheotherSideBear"  maxlength="7"
											onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
											:placeholder="$t('accidentManagement.inputotherparty')"></el-input>
									</el-form-item>
								</el-form>
							</div>
						</el-col>
						<el-col :span="12">
							<div class="grid-content bg-purple-light">
								<el-form :model="accidentRegistration" class="demo-form-inline" label-position="right"
									size="mini" :label-width="(LanguageId  == 1 ||LanguageId  == 2) ? '100px' : '230px'" style="margin-top: 15px;">
									<el-form-item :label="$t('accidentManagement.ourresponsible')+'：'" style="margin-top: 15px;" prop="OurresponsibleWeight">
										<el-input v-model="accidentRegistration.OurresponsibleWeight"  maxlength="7"
											onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
											:placeholder="$t('accidentManagement.inputourresponsible')"></el-input>
									</el-form-item>
									<el-form-item :label="$t('accidentManagement.assumedbycompany')+'：'" style="margin-top: 15px;" prop="OurcompanyBear">
										<el-input v-model="accidentRegistration.OurcompanyBear"  maxlength="7"
											onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
											:placeholder="$t('accidentManagement.inputassumedbycompany')"></el-input>
									</el-form-item>
									<el-form-item :label="$t('accidentManagement.responsibleperson')+'：'" style="margin-top: 15px;" prop="PersonResponseBear">
										<el-input v-model="accidentRegistration.PersonResponseBear"  maxlength="7"
											onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
											:placeholder="$t('accidentManagement.inputresponsibleperson')"></el-input>
									</el-form-item>
								</el-form>
							</div>
						</el-col>
					</el-row>
					<el-form :inline="true" :model="accidentRegistration" class="demo-form-inline"
						label-position="right" :label-width="(LanguageId  == 1 ||LanguageId  == 2) ? '100px' : '230px'" style="margin-top: 10px;">
						<el-form-item :label="$t('accidentManagement.accidentlocation')+'：'" >
							<el-input type="textarea" v-model="accidentRegistration.AccidentSpot"    maxlength="50"
								:placeholder="$t('accidentManagement.inputaccidentlocation')"></el-input>
						</el-form-item>

						<el-form-item :label="$t('accidentManagement.accidentDescription')+'：'">
							<el-input type="textarea" v-model="accidentRegistration.AccidentDescription"     maxlength="100"
								:placeholder="$t('accidentManagement.inputaccidentDescription')"></el-input>
						</el-form-item>
					</el-form>
					<div slot="footer" class="dialog-footer" style="text-align: right;margin:-20px 0px 20px 10px">
						<el-button size="small" @click="dialogFormVisible = false">{{$t('public.cancel')}}</el-button>
						<el-button size="small" type="primary" @click="determineaccident('accidentRegistration')">{{$t('public.confirm')}}</el-button>
					</div>

				</el-dialog>
			</div>
		</div>
	</div>
</template>

<script>
	import language from '@/utils/getLanguageId';
	import generalOrQuickQuery from '@/views/maintenancemanagement/components/generalOrQuickQuery.vue'
	import {
		mapState
	} from 'vuex'
	export default {
		name:"accidentManagement",
		components: {
			generalOrQuickQuery
		},
		data() {
			return {
				LanguageId:1,
				pickerOptions: {
					disabledDate(time) {
						return time.getTime() > Date.now();
					}
				},
				// total: 0,
				// currentPage: 1,
				// pageSize: 10,
				vehicleselect: {
					carno: "",
				},
				days: "",
				accidenttitle: "",
				dialogFormVisible: false,
				accidentID: 0,
				tableData: [],
				accidentRegistration: {
					// InputTime: new Date(),
					// AccidentTime:new Date()
				},
				newsearchType: 0,
				form1: {},
				begindate: "",
				enddate: "",
				rules: {
					Driver: [{
						required: true,
						message: this.$t('vehicleInfo.inputdrivername'),
						trigger: 'blur'
					}],
					VID: [{
						required: true,
						message:this.$t('maintenancemanagement.selectvehicle'),
						trigger: 'change'
					}],

				}
			}
		},

		computed: {
			size() {
				return this.$store.getters.size
			},
			...mapState({
				operator: state => state.user.operator,
				vehicles: state => state.app.vehicles,
			})
		},
		mounted() {
			var that = this;
			 that.LanguageId = language(that.$store.getters.locale)
			console.log(that.vehicles);
			console.log(that.operator);
			// that.accidentRegistration.DataEntryClerk=that.operator.OpeName
			// let myDate = new Date();
			// that.begindate = that.getNextDate(myDate, -30);
			// that.enddate = that.getNextDate(myDate, 0);
			// console.log(that.begindate);
			// console.log(that.enddate);
			// that.queryAccidentInfo(that.begindate, that.enddate, '', 0);
		},
		methods: {
			handleQuery(val) {
				if(!val.beginDate&&!val.endDate){
					this.$message.warning(this.$t("time.selectQueryTime"));
					return;
				}
				this.form1 = val;
				console.log(this.form1)
				delete this.form1.speed;
				delete this.form1.pageNum;
				delete this.form1.pageSize;
				
				this.begindate = this.form1.beginDate;
				this.enddate = this.form1.endDate;
				this.queryAccidentInfo(this.begindate, this.enddate, this.vehicleselect.carno, 0);
			},
			quickQuery(val) {
				this.form1 = val;
				console.log(this.form1)
				delete this.form1.speed;
				delete this.form1.pageNum;
				delete this.form1.pageSize;
				this.begindate = this.form1.beginDate;
				this.enddate = this.form1.endDate;
				this.queryAccidentInfo(this.begindate, this.enddate, this.vehicleselect.carno, 0);
			},
			queryAccidentInfo(begindate, enddate, vehicle, type) {
				var that = this;
				// that.loading = true;
				this.$api.queryAccidentInfo({
					// CarNo: this.vehicleselect.carno,
					CarNo: vehicle,
					OperatorID: this.operator.OperatorId,
					// V_ID: vehicle, //128717
					BeginDate: begindate,
					EndDate: enddate,
					IsExport: type,
					// this.pageSize 加分页参数
				}).then((res) => {
					console.log(res);
					if (type == 0) {
						if (res.type == "application/json") {
							const reader = new FileReader();
							reader.readAsText(res, 'utf-8');
							reader.onload = function(e) {
								const readerres = reader.result;
								const parseObj = JSON.parse(readerres);
								console.log(parseObj);
								that.total = parseObj.count;
								console.log(that.total);
								if (parseObj.data.length > 0) {
									that.tableData = parseObj.data;
									that.loading = false;
								} else {
									that.tableData = [];
								}
							}
						}
					} else {
						// that.loading = false;
						let blob = new Blob([res], {
							type: "application/vnd.ms-excel;charset=utf-8"
						}); // 重点代码
						let a = document.createElement("a");
						a.href = window.URL.createObjectURL(blob);
						a.setAttribute("download",that.$t('accidentManagement.accident') +
							`_${that.timestampToTime(new Date().getTime())}.xlsx`); // 表名，自定义
						a.click(); // 执行下载
						window.URL.revokeObjectURL(blob); // 释放ur
					}
				})


			},
			// handleSizeChange(val) {
			// 	this.pageSize = val;
			// 	this.queryAccidentInfo(this.begindate, this.enddate, this.vehicleselect.carno, 0);
			// },
			// handleCurrentChange(val)  {

			// },
			//时间戳转换为日期格式
			timestampToTime(timestamp) {
				var date = new Date(timestamp); //时间数为10位篇*1000，时间数为13位的话不需乘1000
				var Y = date.getFullYear();
				var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
				var D = date.getDate();
				var h = date.getHours();
				var m = date.getMinutes();
				var s = date.getSeconds();
				return Y + M + D + h + m + s;
			},
			//新建事故
			newaccident() {
				this.accidenttitle =this.$t('accidentManagement.accidentRegistration');
				this.dialogFormVisible = true;
				this.accidentRegistration = {};
				this.$nextTick(() => {
					this.$refs["accidentRegistration"].clearValidate();
				})
				this.$set(this.accidentRegistration, "DataEntryClerk", this.operator.OpeName);
				this.$set(this.accidentRegistration, "AccidentTime", new Date());
				this.$set(this.accidentRegistration, "InputTime", new Date());
			},

			determineaccident(formName) {
				console.log(this.accidentRegistration)
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (this.accidenttitle == this.$t('accidentManagement.accidentRegistration')) {
							this.saveAccidentInfo(this.accidentID, 1, this.$t('public.add_success'))                       
						} else if (this.accidenttitle ==this.$t('accidentManagement.modifyaccident')) {
							// this.saveAccidentInfo(row.AccidentID, 2);
							this.saveAccidentInfo(this.accidentID, 2, this.$t('public.edit_success'))
						}
					} else {
						// console.log('error submit!!');
						return false;
					}
				});
			},
			modify(index, row) {
				console.log(index)
				console.log(row)
				this.accidenttitle = this.$t('accidentManagement.modifyaccident');
				this.dialogFormVisible = true;
				this.accidentID = row.AccidentID;
				const {
					AccidentDescription,
					AccidentID,
					AccidentSpot,
					AccidentTime,
					VID,
					Driver,
					InsuranceUnderwrite,
					OurcompanyBear,
					OurresponsibleWeight,
					PersonResponseBear,
					TheotherSideBear,
					TotalCompensation,
				} = row;
				let newvehicle = this.vehicles.data.filter((item, index) => {
					return item.treeLevel == 5
				})
				newvehicle.forEach(function(item, index) {
					if (item.vehicleName == row.CarNo) {
						row.VID = item.nodeValue;
					}
				});
				this.accidentRegistration = JSON.parse(JSON.stringify(row)); ////数据赋值 深拷贝代替浅拷贝

			},
			saveAccidentInfo(accidentID, type, message) {
				this.$api.saveAccidentInfo({
					AccidentID: accidentID,
					V_ID: this.accidentRegistration.VID,
					Driver: this.accidentRegistration.Driver,
					AccidentTime: this.accidentRegistration.AccidentTime,
					OurresponsibleWeight: this.accidentRegistration.OurresponsibleWeight,
					TotalCompensation: parseInt(this.accidentRegistration.TotalCompensation) * 100,
					InsuranceUnderwrite: parseInt(this.accidentRegistration.InsuranceUnderwrite) * 100,
					OurcompanyBear: parseInt(this.accidentRegistration.OurcompanyBear) * 100,
					TheotherSideBear: parseInt(this.accidentRegistration.TheotherSideBear) * 100,
					PersonResponseBear: parseInt(this.accidentRegistration.PersonResponseBear) * 100,
					AccidentSpot: this.accidentRegistration.AccidentSpot,
					AccidentDescription: this.accidentRegistration.AccidentDescription,
					operate: type,
					DataEntryClerk: this.accidentRegistration.DataEntryClerk,
					InputTime: this.accidentRegistration.InputTime
				}).then((res) => {
					console.log(res)
					if (res.code == 200) {
						this.dialogFormVisible = false;
						this.accidentRegistration = {};
						this.$message({
							type: 'success',
							message: message,
						});
						// let myDate = new Date();
						// this.begindate = this.getNextDate(myDate, -7);
						// this.enddate = this.getNextDate(myDate, 0);
						this.queryAccidentInfo(this.begindate, this.enddate, '', 0);
					} else {
						this.$message({
							type: 'info',
							message: res.message,
						});
					}
				})
				// }
			},
			download() {
				if (this.tableData.length == 0) {
					this.$message.info(this.$t("statistics.PleQuery"));
					return;
				}
				this.queryAccidentInfo(this.begindate, this.enddate, this.vehicleselect.carno, 1);
			},
			handleDelete(index, row) {
				console.log(index, row.AccidentDescription);
				this.$confirm(this.$t('maintenance.confirmDelete')+'?', this.$t('public.tips'), {
					confirmButtonText: this.$t('public.confirm'),
					cancelButtonText: this.$t('public.cancel'),
					type: 'warning'
				}).then(() => {
					const {
						AccidentDescription,
						AccidentID,
						AccidentSpot,
						AccidentTime,
						CarNo,
						Driver,
						InsuranceUnderwrite,
						OurcompanyBear,
						OurresponsibleWeight,
						PersonResponseBear,
						TheotherSideBear,
						TotalCompensation,
					} = row;
					this.accidentRegistration = JSON.parse(JSON.stringify(row)); ////数据赋值 深拷贝代替浅拷贝
					this.saveAccidentInfo(this.accidentRegistration.AccidentID, 3, this.$t('public.hasDeleted'));
					// row.splice(index, 1);
				}).catch(() => {
					// this.$message({
					//   type: 'info',
					//   message: '已取消删除'
					// });          
				});
			},
			getNextDate(date, day) {
				const dd = new Date(date);
				dd.setDate(dd.getDate() + day);
				const y = dd.getFullYear();
				const m = dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
				const d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
				return y + "-" + m + "-" + d;
			},
		}




	}
</script>

<style lang="scss" scoped>
	.addrepairlist   {
		::v-deep	.el-dialog {
			height: 597px;
		}
	}

	.page_header  {
		::v-deep .el-form-item__label {
			font-size: 12px;
		}
	}

	.addbutton {
		text-align: right;
		right: 0;
		position: absolute;
		margin-right: 40px;
	}

	.registrationInfo {
		margin-top: 20px;
		font-size: 12px;
		text-align: left;
		font-weight: bold !important;
		margin-left: 20px;
		color: black;
	}

	.addrepairlist  {
		::v-deep	.el-form-item__label {
			font-size: 12px;

		}
	}
	.addrepairlist   {
		::v-deep	.el-textarea__inner {
			width: 450px;
			font-size: 12px;
		}
	}

	.carno   {
		::v-deep	.el-select>.el-input {
			font-size: 12px;
		}
	}
</style>